import type { ThematicConfig } from '#types/config/components/thematic'

export default {
  brandClasses: {
    title: 'title-1 text-left'
  },
  isCmsTitle: true
} satisfies ThematicConfig
